/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PurposeType {
    ApplicantBankAccountDebt = 'APPLICANT_BANK_ACCOUNT_DEBT',
    ApplicantBankAccount = 'APPLICANT_BANK_ACCOUNT',
    CreditorDebt = 'CREDITOR_DEBT',
    Execution = 'EXECUTION',
    DealRefinancing = 'DEAL_REFINANCING',
    Commission = 'COMMISSION',
    OverpaidRent = 'OVERPAID_RENT',
    ToSellingBankAccount = 'TO_SELLING_BANK_ACCOUNT',
    LiabilityPayment = 'LIABILITY_PAYMENT'
}

export function PurposeTypeFromJSON(json: any): PurposeType {
    return PurposeTypeFromJSONTyped(json, false);
}

export function PurposeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurposeType {
    return json as PurposeType;
}

export function PurposeTypeToJSON(value?: PurposeType | null): any {
    return value as any;
}

